import linearSad from '../../assets/img/linear_sad.svg';
import LinearFooterCmp from "../../components/footer/LinearFooter";
import { LEndSection } from "../../components/styled/Containers.style";
import { LIconContainer } from "../../components/styled/Icon.style";
import { Vspace } from "../../components/styled/Separators.style";
import { LEndPageTitle, LEndText } from "../../components/styled/Text.style";
import { AUTH_CONFIRM_PATHS } from "../../routes/AuthConfirmRouter";
import { LINEAR_PATHS } from "../../routes/linearRouteConstants";
import { selectCommunicationData } from '../../store';
import { useAppSelector } from '../../store/hooks';
import { hasCommSignatureEvent } from '../../utils/utils';
import PageContainerCmp from "../PageContainerCmp";

/* istanbul ignore next */
interface EndTokenExpiredLinearPageProps {
    isCtp?: boolean;
}

const EndTokenExpiredLinearPage = ({ isCtp }: EndTokenExpiredLinearPageProps) => {

    const communicationData = useAppSelector(selectCommunicationData)
    const { communication } = communicationData

    let hasSign = hasCommSignatureEvent(communication)

    return (
        <>

            <PageContainerCmp
                routePath={isCtp === true ? AUTH_CONFIRM_PATHS.AUTHORIZE_CONFIRM_TOKEN_EXPIRED : LINEAR_PATHS.TOKEN_EXPIRED}
                removeNextBtn
                isForceLastPathname={true}
            >
                <LEndSection>

                    <LIconContainer style={{ marginTop: "-220px" }}>
                        <img
                            src={linearSad}
                            alt="Tempo Scaduto"
                            style={{ width: "250px" }}
                        />
                    </LIconContainer>

                    <LEndPageTitle>LINK SCADUTO</LEndPageTitle>
                    <Vspace qty={2}></Vspace>

                    {(new URLSearchParams(window?.location?.search || '')).get('invalid') === 'true' ?
                        <LEndText>Siamo spiacenti ma questa comunicazione è stata annullata e inoltrata ad un altro numero.</LEndText> :
                        <>{hasSign === true ?
                            <LEndText>Siamo spiacenti ma il link è scaduto.</LEndText> :
                            <LEndText>Siamo spiacenti ma {isCtp === true ? "le 24 ore" : "i 15 giorni"} per compilare questa procedura sono scadut{isCtp === true ? "e" : "i"}.</LEndText>
                        }</>
                    }

                    {isCtp === false ? <>
                        <Vspace qty={2}></Vspace>
                        <LEndText>Contatta la tua Compagnia per proseguire.</LEndText>
                        <LEndText>Grazie</LEndText>
                    </> : <></>}

                </LEndSection>

                <LinearFooterCmp inverted={true} />

            </PageContainerCmp>
        </>

    )
}

export default EndTokenExpiredLinearPage